<template>
  <div
    id="main-container"
    :class="
      $store.state.app.collapse ? 'main-container-collapse' : 'main-container'
    "
  >
    <div class="menuCollapseBar" @click="handleCollapse()">
      <span class="arrow" :class="{ 'is-active': $store.state.app.collapse }"
        >></span
      >
    </div>
    <!-- 主内容区域 -->
    <div class="main-content">
      <div class="content">
        <keep-alive>
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleCollapse() {
      this.$store.commit("onCollapse");
    },
  },
};
</script>

<style scoped lang="scss">
.menuCollapseBar {
  background-color: rgba($color: #768c95, $alpha: 0.9);
  position: absolute;
  height: 8%;
  width: 18px;
  left: 0px;
  top: 46%;
  border-radius: 0 8px 8px 0;
  cursor: pointer;
  z-index: 1;
  display: flex;
}

.menuCollapseBar:hover {
  background-color: #5E7077;
}

.arrow {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
  color: #ffffff;
  display: block;
  margin: auto;
  transform: rotate(180deg);
  transition: 0.38s;
  transform-origin: 50% 50%;
}

.is-active {
  transform: rotate(0deg);
}

.main-container {
  // padding: 0 5px 5px;
  position: absolute;
  top: 60px;
  left: 201.6px;
  right: 1px;
  bottom: 0px;
}

.main-container-collapse {
  position: absolute;
  top: 60px;
  left: 60px;
  right: 1px;
  bottom: 0px;
}

.main-content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 0px;
  overflow: auto;
}

.content {
  min-width: 1024px; // 设置的最小宽度，小于1024时，会出现滚动条
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/MainContent/MainContent.vue